<template>
  <div>
    <card>
      <div class="row no-gutters mb-3">
        <div class="col-12 d-flex justify-content-start">
          <el-button class="print-btn" size="small" type="success" @click="print">
            <i class="fa-solid fa-print"></i> &nbsp;{{$t('Çap_forması')}}
          </el-button>
        </div>
      </div>
      
      <el-form label-width="200px" :label-position="labelPosition" size="small">
        <div class="row no-gutters">
          <div class="col-6">
            <div class="section-header">
              <titles :text="$t('Ödəniş_alanın_məlumatları')"></titles>
              <hr class="section-divider">
            </div>
            <div class="row no-gutters info-section">
              <div :class="['col-4', textLeft, 'pd label']">{{$t('Sığorta_növü')}}</div>
              <div class="col-8 pd value">{{ item.insuranceTypeName }}</div>
              
              <div v-if="item.assessmentStatus === 6" :class="['col-4', textLeft, 'pd label']">
                {{$t('Ödəniş_alacaq_T/M')}}
              </div>
              <div v-if="item.assessmentStatus === 6" class="col-8 pd value">
                {{ item.serviceCenterName }}
              </div>
              
              <div :class="['col-4', textLeft, 'pd label']">{{$t('Status')}}</div>
              <div class="col-8 pd value">
                {{ assessmentStatus === 4 ? $t('Müştəri_ilə_razılaşdırılıb') : $t('Təmir_olunub') }}
              </div>
              
              <div v-if="item.assessmentStatus !== 6" :class="['col-4', textLeft, 'pd label']">
                {{$t('Ödəniş_alacaq_şəxs')}}
              </div>
              <div v-if="item.assessmentStatus !== 6" class="col-8 pd value">
                {{ item.personName }}
              </div>
              
              <div v-if="item.assessmentStatus !== 6" :class="['col-4', textLeft, 'pd label']">
                {{$t('Fin')}}
              </div>
              <div v-if="item.assessmentStatus !== 6" class="col-8 pd value">
                {{ item.identNumber }}
              </div>
              
              <div v-if="item.assessmentStatus !== 10" :class="['col-4', textLeft, 'pd label']">
                {{$t('Şəxsin_növü')}}
              </div>
              <div v-if="item.techExpertStatus !== 6" class="col-8 pd value">
                {{ item.personTypeName }}
              </div>
              
              <div :class="['col-4', textLeft, 'pd label']">{{$t('Son_məbləğ')}}</div>
              <div class="col-8 pd value">{{ item.paymentSum }}</div>
              
            
            </div>
          </div>
          
          <div class="col-6">
            <div class="section-header">
              <titles :text="$t('Bank_məlumatları')"></titles>
              <hr class="section-divider">
            </div>
            <div class="row no-gutters info-section">
              <div v-if="item.assessmentStatus === 6" :class="['col-4', textLeft, 'pd label']">
                {{$t('VÖEN_T/M')}}
              </div>
              <div v-if="item.assessmentStatus === 6" class="col-8 pd value">
                {{ item.serviceTin }}
              </div>
              
              <div :class="['col-4', textLeft, 'pd label']">{{$t('VÖEN_Bank')}}</div>
              <div class="col-8 pd value">{{ item.tin }}</div>
              
              <div :class="['col-4', textLeft, 'pd label']">{{$t('Müxbir_hesab')}}</div>
              <div class="col-8 pd value">{{ item.cbAccount }}</div>
              
              <div :class="['col-4', textLeft, 'pd label']">{{$t('Kod')}}</div>
              <div class="col-8 pd value">{{ item.code }}</div>
              
              <div :class="['col-4', textLeft, 'pd label']">{{$t('Swift')}}</div>
              <div class="col-8 pd value">{{ item.swift }}</div>
            </div>
          </div>
          <div class="col-12">
            <div class="row no-gutters info-section">
              <div class="col-12 pd">
                <div class="d-flex align-items-center">
                  <div :class="[textLeft, 'label']" style="width: 200px;">
                    {{$t('Bank_Hesab_nömrəsi')}}
                  </div>
                  <div class="value d-flex align-items-center" style="flex-grow: 1;margin-left: -8px;margin-top: -4px;">
                    <span v-if="item.bankAccount" class="mr-1">{{ item.bankAccount }}</span>
                    <span v-else style="color: #999;" class="mr-1">{{$t('Daxil_olunmayıb')}}</span>
                    
                    <!-- Buttons placed right next to the value -->
                    <div style="margin-left: 5px;">
                      <el-button 
                        v-if="!item.bankAccount"
                        type="primary" 
                        size="small"
                        @click="bankModal"
                        class="action-btn"
                      >
                        {{$t('Daxil_et')}}
                      </el-button>
                      <el-button 
                        v-if="item.bankAccount"
                        type="text" 
                        @click="bankModal" 
                        class="custom-button p-0"
                      >
                        <i class="fas fa-ellipsis-v action-icon"></i>
                      </el-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </el-form>
      
      <div class="row no-gutters mt-4">
        <div class="col-6 d-flex justify-content-start">
          <upload 
            :disabled="readonly" 
            ref="upload" 
            :sourcetype="7" 
            :sourceId="item.id" 
            :autoupload="true"
            :downloadAll="true" 
            listtype="text"
          ></upload>
        </div>
      </div>
    </card>
    
    <bank-modal @refresh="getData" ref="bank" />
    
    <el-dialog width="78%" top="1vh" :visible.sync="printDialogVisible" center>
      <el-button size="small" class="print-action-btn" id="button" v-print="'#printMe1'" type="success">
        <i class="fa-solid fa-print"></i> &nbsp;{{$t('Çap_et')}}
      </el-button>
      <div id="printMe1" ref="printMeRef1">
        <div v-if="policyType === 1">
          <div v-if="actPrint.zbt === 1">
            <act-print-zbt v-if="actPrint" :value="actPrint" />
          </div>
          <div v-else>
            <act-print v-if="actPrint" :value="actPrint" />
          </div>
        </div>
        <div v-else>
          <act-print-payment v-if="actPrint" :value="actPrint" />
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ActPrintPayment from "../components/ActPrintPayment.vue";
import ActPrint from "../components/ActPrint.vue";
import ActPrintZbt from "../components/ActPrintZbt.vue";
import BankModal from "../servicecenter/BankModal.vue";
import Upload from "../components/Upload.vue";
import { labelPosition, textLeft } from "../../services/helper";
import { LastAssessmentStatus } from "../../services/common";
import Titles from "./Titles.vue";

export default {
  components: {
    Titles,
    BankModal,
    Upload,
    ActPrintPayment,
    ActPrintZbt,
    ActPrint
  },
  props: {
    value: Object,
    readonly: { type: Boolean, default: false },
    actPrint: {},
    policyType: { type: Number, default: 0 },
  },
  data() {
    return {
      item: this.value,
      assessmentStatus: null,
      printDialogVisible: false,
      labelPosition: labelPosition,
      textLeft: textLeft,
    };
  },
  methods: {
    print() {
      this.printDialogVisible = true;
    },
    bankModal() {
      this.$refs["bank"].edit(this.item);
    },
    getData() {
      this.$emit("refresh");
    },
    lastAssessmentStatus() {
      return new Promise((resolve, reject) => {
        LastAssessmentStatus(this.item.claimId).then((response) => {
          if (response.data) {
            this.assessmentStatus = response.data;
          }
          resolve(this.response);
        }, error => {
          reject(error);
        })
      })
    },
  },
  mounted() {
    this.lastAssessmentStatus();
  },
  watch: {
    value() {
      this.item = this.value;
    },
  },
};
</script>

<style lang="scss" scoped>
.no-gutters {
  margin-right: 0;
  margin-left: 0;
  
  > .col,
  > [class*="col-"] {
    padding-right: 0;
    padding-left: 0;
  }
}


.label {
  font-weight: 600;
  color:#3A3A3A !important;
  font-size: var(--font-primary);
}

.value {
  color: #333;
  font-size: var(--font-primary);
}

.section-header {
  padding-bottom: 4px;
}

.section-divider {
  margin: 4px 0 8px 0;
  height: 1px;
  background: #e0e0e0;
  border: none;
}

.info-section {
  color: var(--font-primary) !important;
  font-size: 12px;
}

.bank-account-section {
  margin-top: 12px;
  color: var(--font-primary) !important;
  font-size: var(--font-primary);
}

.bank-label {
  font-weight: 600;
  color:#3A3A3A !important;
   font-size: var(--font-primary);
}

.account-number {
  padding-left: 8px;
  font-size: var(--font-primary);
}

.print-btn {
  height: 32px;
  font-size: var(--font-primary);
}

.print-action-btn {
  margin-bottom: 10px;
  font-size: var(--font-primary);
}

.action-btn {
  height: 28px;
  font-size: var(--font-primary);
  padding: 0 12px;
}

.action-icon {
  color: #808080;
  font-size: var(--font-medium);
}

.custom-button {
  padding: 0 7px;
  margin-left: 8px;
}

.ml-2 {
  margin-left: 8px;
}

.mb-3 {
  margin-bottom: 16px;
}

.mt-4 {
  margin-top: 20px;
}

.el-button--small {
  padding: 7px 12px;
}

.card form [class*=col-]:first-child {
    padding-left: 0;
}

.value span {
  display: inline-block;
  padding-top: 2px; /* Diğer değerlerle tam aynı hizaya gelmesi için */
}

/* Əsas Stil Tənzimləmələri */
.bank-account {
  display: flex;
  align-items: center;
  padding: 6px 0;
  min-height: 32px;
}

.full-width-line {
  display: flex;
  width: 100%;
  align-items: center;
}

.account-text {
  flex: 1;
  white-space: nowrap; /* Mətni tək sətirdə saxlayır */
  overflow: hidden;
  text-overflow: ellipsis; /* Çox uzun mətnə "..." əlavə edir */
  padding-right: 8px;
}

.account-actions {
  flex-shrink: 0;
  margin-left: auto;
}

/* Düymə stilləri */
.action-btn {
  height: 28px;
  padding: 0 12px;
}

.custom-button {
  padding: 0 7px;
}



</style>